/// <amd-module name="Feed/Legacy/Protocols/PyPi/PyPiOverviewAttributesPanel" />
import * as React from "react";

import * as PackageResources from "Feed/Common/Resources";
import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { PackageDependencies } from "Feed/Legacy/Protocols/Components/PackageDependencies";
import { IProjectAttribute, PackageDevelopment } from "Feed/Legacy/Protocols/Components/PackageDevelopment";
import { PackageProvenance } from "Feed/Legacy/Protocols/Components/PackageProvenance";
import { PackageStats } from "Feed/Legacy/Protocols/Components/PackageStats";
import { PackageTags } from "Feed/Legacy/Protocols/Components/PackageTags";
import { IPyPiProtocolMetadata } from "Feed/Legacy/Protocols/PyPi/IPyPiProtocolMetadata";
import { PyPiPackagePeople } from "Feed/Legacy/Protocols/PyPi/PyPiPackagePeople";

export class PyPiOverviewAttributesPanel extends React.Component<IPackageDetailsProps> {
    public render(): JSX.Element {
        const pypiMetadata: IPyPiProtocolMetadata =
            this.props.packageVersion.protocolMetadata && this.props.packageVersion.protocolMetadata.data
                ? (this.props.packageVersion.protocolMetadata.data as IPyPiProtocolMetadata)
                : ({} as IPyPiProtocolMetadata);

        const projectAttributes: IProjectAttribute[] = [];

        return (
            <div className="pypi-overview-attributes-panel">
                <PackageProvenance
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageId={this.props.packageSummary.id}
                    versionId={this.props.packageVersion.id}
                    publishDate={new Date(this.props.packageVersion.publishDate)}
                    isProvenanceEnabled={this.props.isProvenanceEnabled}
                    isProvenanceSupported={true}
                />
                <PyPiPackagePeople
                    pageContext={this.props.pageContext}
                    author={pypiMetadata.author}
                    authorEmail={pypiMetadata.authorEmail}
                    maintainer={pypiMetadata.maintainer}
                    maintainerEmail={pypiMetadata.maintainerEmail}
                />
                <PackageDevelopment
                    pageContext={this.props.pageContext}
                    projectAttributes={projectAttributes}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    upstreamSources={this.props.feed.project ? null : this.props.feed.upstreamSources}
                />
                {this.props.isMetricsEnabled && (
                    <PackageStats
                        packageVersionMetrics={this.props.packageVersionMetrics}
                        packageMetrics={this.props.packageMetrics}
                        isMetricsLoading={this.props.isMetricsLoading}
                        feed={this.props.feed}
                    />
                )}
                <PackageDependencies
                    pageContext={this.props.pageContext}
                    feed={this.props.feed}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    isSmartDependenciesEnabled={this.props.isSmartDependenciesEnabled}
                />
                <PackageTags tags={pypiMetadata.classifiers} title={PackageResources.PyPiPackage_Classifiers} />
            </div>
        );
    }
}
